import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { OrganisationService } from "../../services/organisation/organisation.service";

@Component({
  selector: 'app-preview-questionnaire',
  templateUrl: './preview-questionnaire.component.pug',
  styleUrls: ['./preview-questionnaire.component.scss'],
  standalone: false
})
export class PreviewQuestionnaireComponent implements OnInit {
  createSurvey = false;
  questionnaireId = '';
  questions: any[] = [];
  questionnaireTitle = '';
  is_additional_comments_enabled=false
  surveyType = 'exit';
  pageType = '';
  org_name='';
  org_notes: any;
  survey_notes: any;
  custom = $localize`Custom`;
  default = $localize`Default`;
  questionnaireIsDefault = false;
  candidate_note = '';
  employment_note = '';
  min_referee = '';
  persona_questions:any={
    'candidate': [],
    'employment': [],
    'academic': [],
    'character': [],
    'voluntary': [],
    'exit': []
  };
  @Output() nextClick:EventEmitter<any> = new EventEmitter();

  loading = true;

  constructor( private questionnaireService: QuestionnaireService,
               private metricIconService: MetricIconService,
               public bsModalRef: BsModalRef,
               private organisationService:OrganisationService) {
    }

  ngOnInit(): void {
    if (this.questionnaireId != '') {
      this.questionnaireService.getQuestionnaire(this.questionnaireId, true).subscribe((res) => {
        this.questions = res['data']['questions'];
        this.is_additional_comments_enabled = res['data']['is_additional_comments_enabled']
        this.questions.forEach((q: any) => {
          if (Object.keys(this.persona_questions).findIndex(k => k == q['category'].toLowerCase()) != -1) {
            if (res.data['survey_type'] == 'reference') this.surveyType = 'reference';
            this.persona_questions[q['category'].toLowerCase()].push(q);
          } else {
            this.persona_questions['exit'].push(q);
          }
        })
        this.questionnaireTitle = res['data']['name']

        this.survey_notes = res?.data?.config?.notes;
        this.min_referee = res?.data?.config?.min_referee?.toString() ?? '';
        this.questionnaireIsDefault = res?.data?.questions?.[0]?.questionnaire?.is_default ?? false;

        this.organisationService.getOrganisation().subscribe({
          next: (resOrg) => {
            this.org_name = resOrg?.brand_name;
            this.org_notes = resOrg?.notes;
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        })

        if (res.data['survey_type'] == 'reference') {
          const is_opt_in_question_enabled = res.data['is_opt_in_question_enabled'] || false;
          if (is_opt_in_question_enabled) {
            const opt_in_question = {
              'question_text': res.data['opt_in_question']?.replace('{{organisation}}', this.org_name) || '',
              'is_opt_in_question_enabled': is_opt_in_question_enabled,
            }
            this.persona_questions['employment'].unshift(opt_in_question);
          }
        }

        if(this.questionnaireIsDefault){
          this.candidate_note = this.default;
          this.employment_note = this.default;
        }
        else {
          this.candidate_note = this.survey_notes?.note_to_candidate == this.org_notes?.note_to_candidate ? this.default : this.custom;
          this.employment_note = this.survey_notes?.note_to_referee == this.org_notes?.note_to_referee ? this.default : this.custom;
        }
      },
      (error) => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  getMetricIcon(metric) {
    return this.metricIconService.getMetricIcon(metric);
  }

  cancel(){
    this.bsModalRef.hide();
  }

  next(){
    this.nextClick.emit();
    this.bsModalRef.hide();
  }

}
